$.fn.radioReplace = function() {
    $(this).each(function() {
        var current = $(this);

        if (current.parent().hasClass('radio-replace') || current.parent().hasClass('radio-replace-alt') || current.attr('data-no-replace')) {
            return;
        }

        current.wrap('<div class="radio-replace-alt"></div>').hide();

        var wrap = $(this).parent();

        current.change(function (e) {
            $('input[type=radio][name="' + $(this).attr('name') + '"]').each(function() {
                $(this).parent().removeClass('radio-replace-alt--active');
            });

            if (current.prop('checked')) {
                wrap.addClass('radio-replace-alt--active');
            }

            return true;
        });

        $(this).trigger('change');

        // Trigger the initial state
        $('input[type=radio][name="' + $(this).attr('name') + '"][checked]').trigger('change');
    });
};
